module.exports = "<app-notifications></app-notifications>"